import { render, staticRenderFns } from "./ChatMessageItem.vue?vue&type=template&id=0cd718d1&scoped=true"
import script from "./ChatMessageItem.vue?vue&type=script&lang=js"
export * from "./ChatMessageItem.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageItem.vue?vue&type=style&index=0&id=0cd718d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd718d1",
  null
  
)

export default component.exports